import { useEffect } from 'react'

import { useApi } from '../../../../hooks'
import { toggleEmailRead } from '../../Email.api'

export function useEmailProfileRead({
  isEnabled = true,
  mailUuid,
  readApi = toggleEmailRead,
  single,
  onSuccessRead,
}) {
  const api = useApi()

  // Held while the caller still needs the item in its list, e.g. until the
  // navigation lookup has settled under an `unread` filter
  useEffect(() => {
    if (isEnabled) {
      api
        .call(readApi, { read: true, single, uuid: mailUuid })
        .then(response => {
          if (response) {
            onSuccessRead?.(mailUuid)
          }
        })
    }

    return () => {
      api.abort()
    }
  }, [isEnabled, mailUuid])
}
